import type { Component } from "solid-js";

const StaticDefs: Component = () => {
return (
<defs>

  <linearGradient id="paint0_linear_4_7" x1="1" y1="62" x2="88" y2="62" gradientUnits="userSpaceOnUse">
  <stop stop-color="#0045B4"/>
  <stop offset="0.716346" stop-color="white"/>
  <stop offset="1" stop-color="#0045B4"/>
  </linearGradient>
    <linearGradient
      id="paint0_linear_6_626"
      x1="542"
      y1="179"
      x2="542"
      y2="159"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="#BABEC2" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint1_linear_6_626"
      x1="1006"
      y1="423"
      x2="1006"
      y2="403"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="#BABEC2" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint2_linear_6_626"
      x1="518"
      y1="423"
      x2="518"
      y2="403"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="#BABEC2" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint3_linear_6_626"
      x1="488"
      y1="632"
      x2="508"
      y2="632"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="#BABEC2" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint4_linear_6_626"
      x1="307.5"
      y1="179"
      x2="307.5"
      y2="159"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="#BABEC2" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint5_linear_6_626"
      x1="269"
      y1="501"
      x2="269"
      y2="481"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="#BABEC2" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint6_linear_6_626"
      x1="316.5"
      y1="145"
      x2="316.5"
      y2="125"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="#BABEC2" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint7_linear_6_626"
      x1="74"
      y1="288"
      x2="74"
      y2="268"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="#BABEC2" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint8_linear_6_626"
      x1="892.5"
      y1="145"
      x2="892.5"
      y2="125"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="#BABEC2" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint9_linear_6_626"
      x1="831"
      y1="124.5"
      x2="851"
      y2="124.5"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#2D2F31" />
      <stop offset="0.298077" stop-color="#808489" />
      <stop offset="0.653846" stop-color="#6C6F73" />
      <stop offset="1" stop-color="#2D2F31" />
    </linearGradient>
    <linearGradient
      id="paint10_linear_6_626"
      x1="364"
      y1="491"
      x2="393"
      y2="491"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint11_linear_6_626"
      x1="7.5"
      y1="30"
      x2="7.5"
      y2="0"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint12_linear_6_626"
      x1="7.5"
      y1="30"
      x2="7.5"
      y2="0"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint13_linear_6_626"
      x1="6.5"
      y1="30"
      x2="6.5"
      y2="0"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint14_linear_6_626"
      x1="948"
      y1="495"
      x2="977"
      y2="495"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint15_linear_6_626"
      x1="7.5"
      y1="30"
      x2="7.5"
      y2="0"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint16_linear_6_626"
      x1="7.5"
      y1="30"
      x2="7.5"
      y2="0"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint17_linear_6_626"
      x1="6.5"
      y1="30"
      x2="6.5"
      y2="0"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint18_linear_6_626"
      x1="236"
      y1="278"
      x2="265"
      y2="278"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint19_linear_6_626"
      x1="7.5"
      y1="30"
      x2="7.5"
      y2="0"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint20_linear_6_626"
      x1="7.5"
      y1="30"
      x2="7.5"
      y2="0"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint21_linear_6_626"
      x1="6.5"
      y1="30"
      x2="6.5"
      y2="0"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint22_linear_6_626"
      x1="364"
      y1="135"
      x2="393"
      y2="135"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint23_linear_6_626"
      x1="7.5"
      y1="30"
      x2="7.5"
      y2="0"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint24_linear_6_626"
      x1="7.5"
      y1="30"
      x2="7.5"
      y2="0"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint25_linear_6_626"
      x1="6.5"
      y1="30"
      x2="6.5"
      y2="0"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <radialGradient
      id="paint26_radial_6_626"
      cx="0"
      cy="0"
      r="1"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(270 118) rotate(90) scale(49.5 48.4666)"
    >
      <stop stop-color="#8A8A97" />
      <stop offset="0.209336" stop-color="white" />
      <stop offset="1" stop-color="#585C61" />
    </radialGradient>
    <linearGradient
      id="paint27_linear_6_626"
      x1="7.5"
      y1="30"
      x2="7.5"
      y2="0"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint28_linear_6_626"
      x1="276.5"
      y1="150"
      x2="276.5"
      y2="120"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint29_linear_6_626"
      x1="6.5"
      y1="30"
      x2="6.5"
      y2="0"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <radialGradient
      id="paint30_radial_6_626"
      cx="0"
      cy="0"
      r="1"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(515 423) rotate(90) scale(49.5 48.4666)"
    >
      <stop stop-color="#8A8A97" />
      <stop offset="0.209336" stop-color="white" />
      <stop offset="1" stop-color="#585C61" />
    </radialGradient>
    <linearGradient
      id="paint31_linear_6_626"
      x1="7.5"
      y1="30"
      x2="7.5"
      y2="0"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint32_linear_6_626"
      x1="521.5"
      y1="455"
      x2="521.5"
      y2="425"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint33_linear_6_626"
      x1="6.5"
      y1="30"
      x2="6.5"
      y2="0"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <radialGradient
      id="paint34_radial_6_626"
      cx="0"
      cy="0"
      r="1"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(174 508) rotate(-90) scale(29)"
    >
      <stop stop-color="#121315" />
      <stop offset="0.732428" stop-color="white" />
      <stop offset="1" stop-color="#ADADB2" />
    </radialGradient>
    <linearGradient
      id="paint35_linear_6_626"
      x1="7.5"
      y1="30"
      x2="7.5"
      y2="0"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint36_linear_6_626"
      x1="7.5"
      y1="30"
      x2="7.5"
      y2="0"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint37_linear_6_626"
      x1="2.5"
      y1="16"
      x2="2.5"
      y2="0"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint38_linear_6_626"
      x1="2.5"
      y1="16"
      x2="2.5"
      y2="0"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint39_linear_6_626"
      x1="932.5"
      y1="503"
      x2="932.5"
      y2="487"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint40_linear_6_626"
      x1="2.5"
      y1="16"
      x2="2.5"
      y2="0"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <radialGradient
      id="paint41_radial_6_626"
      cx="0"
      cy="0"
      r="1"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(499 571.5) rotate(90) scale(4.5 6.11091)"
    >
      <stop stop-color="#C3C3C3" />
      <stop offset="0.182692" stop-color="#8A8A97" />
      <stop offset="0.625" stop-color="#7B7B7E" />
      <stop offset="1" stop-color="#0F0F10" />
    </radialGradient>
    <linearGradient
      id="paint42_linear_6_626"
      x1="493"
      y1="484.5"
      x2="503"
      y2="484.5"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint43_linear_6_626"
      x1="0"
      y1="2.5"
      x2="10"
      y2="2.5"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint44_linear_6_626"
      x1="484"
      y1="398.5"
      x2="512"
      y2="398.5"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="#E4E9EF" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint45_linear_6_626"
      x1="998"
      y1="211"
      x2="1026"
      y2="211"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="#E4E9EF" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint46_linear_6_626"
      x1="827"
      y1="211"
      x2="855"
      y2="211"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="#E4E9EF" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint47_linear_6_626"
      x1="951"
      y1="401"
      x2="979"
      y2="401"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="#E4E9EF" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint48_linear_6_626"
      x1="435"
      y1="306"
      x2="1085"
      y2="306"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#ADB6BF" />
      <stop offset="0.149038" stop-color="#EDF5FF" />
      <stop offset="0.807692" stop-color="#CFDDEF" />
      <stop offset="1" stop-color="#ADB6BF" />
    </linearGradient>
    <linearGradient
      id="paint49_linear_6_626"
      x1="650.5"
      y1="303"
      x2="650.5"
      y2="283"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#43392A" />
      <stop offset="0.6875" stop-color="#A9906A" />
      <stop offset="1" stop-color="#76644A" />
    </linearGradient>
    <linearGradient
      id="paint50_linear_6_626"
      x1="650.5"
      y1="327"
      x2="650.5"
      y2="307"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#43392A" />
      <stop offset="0.6875" stop-color="#A9906A" />
      <stop offset="1" stop-color="#76644A" />
    </linearGradient>
    <linearGradient
      id="paint51_linear_6_626"
      x1="650.5"
      y1="359"
      x2="650.5"
      y2="339"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#43392A" />
      <stop offset="0.6875" stop-color="#A9906A" />
      <stop offset="1" stop-color="#76644A" />
    </linearGradient>
    <linearGradient
      id="paint52_linear_6_626"
      x1="650.5"
      y1="383"
      x2="650.5"
      y2="363"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#43392A" />
      <stop offset="0.6875" stop-color="#A9906A" />
      <stop offset="1" stop-color="#76644A" />
    </linearGradient>
    <linearGradient
      id="paint53_linear_6_626"
      x1="757.5"
      y1="289"
      x2="757.5"
      y2="279"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint54_linear_6_626"
      x1="595.5"
      y1="287"
      x2="595.5"
      y2="281"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="#BABEC2" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint55_linear_6_626"
      x1="757.5"
      y1="387"
      x2="757.5"
      y2="377"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint56_linear_6_626"
      x1="595.5"
      y1="385"
      x2="595.5"
      y2="379"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="#BABEC2" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint57_linear_6_626"
      x1="493"
      y1="392.5"
      x2="446"
      y2="269.5"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.724561" stop-color="#BABEC2" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint58_linear_6_626"
      x1="786.249"
      y1="397.935"
      x2="786.249"
      y2="214.011"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0.115021" stop-color="#585C61" />
      <stop offset="0.674519" stop-color="#BABEC2" />
      <stop offset="0.874707" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint59_linear_6_626"
      x1="-1084.16"
      y1="397.99"
      x2="-1084.16"
      y2="214.011"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0.115021" stop-color="#585C61" />
      <stop offset="0.674519" stop-color="#BABEC2" />
      <stop offset="0.874707" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint60_linear_6_626"
      x1="367"
      y1="268.5"
      x2="395"
      y2="268.5"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="#E4E9EF" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint61_linear_6_626"
      x1="367"
      y1="397.5"
      x2="395"
      y2="397.5"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="#E4E9EF" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint62_linear_6_626"
      x1="381"
      y1="393"
      x2="381"
      y2="273"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="#BABEC2" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint63_linear_6_626"
      x1="428"
      y1="278"
      x2="428"
      y2="268"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint64_linear_6_626"
      x1="428"
      y1="298"
      x2="428"
      y2="288"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint65_linear_6_626"
      x1="428"
      y1="318"
      x2="428"
      y2="308"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint66_linear_6_626"
      x1="428"
      y1="338"
      x2="428"
      y2="328"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint67_linear_6_626"
      x1="428"
      y1="358"
      x2="428"
      y2="348"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint68_linear_6_626"
      x1="428"
      y1="378"
      x2="428"
      y2="368"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint69_linear_6_626"
      x1="428"
      y1="398"
      x2="428"
      y2="388"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint70_linear_6_626"
      x1="428"
      y1="403"
      x2="428"
      y2="263"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint71_linear_6_626"
      x1="336"
      y1="278"
      x2="336"
      y2="268"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint72_linear_6_626"
      x1="336"
      y1="298"
      x2="336"
      y2="288"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint73_linear_6_626"
      x1="336"
      y1="318"
      x2="336"
      y2="308"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint74_linear_6_626"
      x1="336"
      y1="338"
      x2="336"
      y2="328"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint75_linear_6_626"
      x1="336"
      y1="358"
      x2="336"
      y2="348"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint76_linear_6_626"
      x1="336"
      y1="378"
      x2="336"
      y2="368"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint77_linear_6_626"
      x1="336"
      y1="398"
      x2="336"
      y2="388"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint78_linear_6_626"
      x1="336"
      y1="403"
      x2="336"
      y2="263"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint79_linear_6_626"
      x1="5.01541"
      y1="16.1003"
      x2="5.01541"
      y2="0"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint80_linear_6_626"
      x1="75"
      y1="290"
      x2="75"
      y2="266"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint81_linear_6_626"
      x1="94.5"
      y1="293"
      x2="94.5"
      y2="263"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint82_linear_6_626"
      x1="55.5"
      y1="293"
      x2="55.5"
      y2="263"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint83_linear_6_626"
      x1="525"
      y1="638"
      x2="525"
      y2="614"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint84_linear_6_626"
      x1="520.5"
      y1="671"
      x2="520.5"
      y2="641"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint85_linear_6_626"
      x1="520.5"
      y1="632"
      x2="520.5"
      y2="602"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#585C61" />
      <stop offset="0.697115" stop-color="white" />
      <stop offset="1" stop-color="#8A8A97" />
    </linearGradient>
    <linearGradient
      id="paint86_linear_6_626"
      x1="579"
      y1="607"
      x2="666"
      y2="607"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#0045B4" />
      <stop offset="0.716346" stop-color="white" />
      <stop offset="1" stop-color="#0045B4" />
    </linearGradient>
    <linearGradient
      id="paint87_linear_6_626"
      x1="278"
      y1="674"
      x2="365"
      y2="674"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#0045B4" />
      <stop offset="0.716346" stop-color="white" />
      <stop offset="1" stop-color="#0045B4" />
    </linearGradient>
    <clipPath id="clip0_6_626">
      <rect width="1133" height="777" fill="white" />
    </clipPath>
  </defs>
)};

export default StaticDefs;